/* istanbul ignore file */
import { AccessToken, IdToken } from '../api/user/userApi.models';

export const parseJwtToken = (token: string): AccessToken | IdToken => {
  const base64Url = token.split('.')[1];
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  const jsonPayload = decodeURIComponent(
    window
      .atob(base64)
      .split('')
      .map((c) => {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
      })
      .join(''),
  );

  return JSON.parse(jsonPayload);
};

export const getExpDate = (utcTimestamp: number): Date => {
  return new Date(new Date(0).setUTCSeconds(utcTimestamp));
};
